import DefaultPage from "../DefaultPage/DefaultPage"
const Maintenance = (props) => {

    return (
        <DefaultPage message={props.maintenanceMessage} fullHeight />
    )
}

export default Maintenance